"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _lodash = require("lodash");

var _DeviceParams = _interopRequireDefault(require("../DeviceParams/DeviceParams"));

var _constants = require("../../constants");

require("./Icon.css");

var _common = _interopRequireDefault(require("../../../utils/common"));

var _SVG = _interopRequireDefault(require("../SVG"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Icon = function Icon(_ref) {
  var asset = _ref.asset,
      sizeOfElements = _ref.sizeOfElements,
      onAssetClick = _ref.onAssetClick,
      onRightClick = _ref.onRightClick,
      _ref$isNoParamsSelect = _ref.isNoParamsSelectedTitleShow,
      isNoParamsSelectedTitleShow = _ref$isNoParamsSelect === void 0 ? true : _ref$isNoParamsSelect;
  var pointType = '';

  if ((0, _lodash.includes)([_constants.core.SLD_ICON_TYPES.BREAKER, _constants.core.SLD_ICON_TYPES.ISOLATER], asset.className)) {
    pointType = asset !== null && asset !== void 0 && asset.DoublePoint ? _constants.core.BREAKER_TYPE.DOUBLE_POINT : _constants.core.BREAKER_TYPE.SINGLE_POINT;
  } // used for mouse CB hover


  var title = _common.default.calculateTitleText(asset);

  var renderImage = function renderImage() {
    if (asset.isSVG) {
      return /*#__PURE__*/_react.default.createElement(_SVG.default, {
        mode: _constants.core.MODE.VIEW,
        asset: asset,
        onContextMenu: function onContextMenu(e) {
          e.preventDefault();
          onRightClick(e, asset);
        }
      });
    }

    var TxId = _constants.core.ASSET_PREFIX + asset.txId;
    return /*#__PURE__*/_react.default.createElement("img", {
      src: asset.img_src,
      id: TxId,
      className: "".concat(asset.className, " icon-container"),
      alt: "".concat(TxId, ", ").concat(asset.orientation, ", ").concat(asset.category),
      title: title,
      onContextMenu: function onContextMenu(e) {
        return onRightClick(e, asset);
      },
      onClick: function onClick() {
        onAssetClick(asset);
      }
    });
  };

  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      left: asset.left,
      top: asset.top,
      width: asset.width,
      height: asset.height,
      position: "absolute"
    }
  }, renderImage()), asset.data && asset.assetId && asset.className !== _constants.core.SLD_ICON_TYPES.ISOLATER && asset.className !== _constants.core.SLD_ICON_TYPES.RELAY
  /* added for isolator flow */
  && /*#__PURE__*/_react.default.createElement(_DeviceParams.default, {
    asset: asset,
    width: sizeOfElements.width,
    isNoParamsSelectedTitleShow: isNoParamsSelectedTitleShow
  }));
};

var _default = Icon;
exports.default = _default;